import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

export default function CallToAction() {
  const { t } = useTranslation('about');
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const element = document.getElementById("cta-section");
    if (element) {
      const rect = element.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        setIsVisible(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      id="cta-section"
      className={`text-center py-20 px-6 sm:px-12 transition-transform duration-500 ${
        isVisible ? "animate-slideUp" : "opacity-0"
      }`}
    >
      <h2 className="text-4xl font-bold text-primary sm:text-5xl">
        {t('cta.title')}
      </h2>
      <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
        {t('cta.description')}
      </p>
      <div className="mt-6 space-x-4">
        <a
          href="/contact"
          className="px-6 py-3 text-lg font-medium text-white bg-primary rounded-lg hover:bg-opacity-80 transition"
        >
          {t('cta.button')}
        </a>
      </div>
    </div>
  );
}
